import React, { useRef } from 'react';

import { Job } from '@utils/aboutInterfaces';

import Address from '../About/Address';
import ContactUs from '../About/ContactUs';
import Testimonials from '../About/Testimonials';
import Careers from './Careers';
import Header from './Header';
import Statistics from './Statistics';
import Timeline from './Timeline';

interface JobProps {
  jobs: Job[];
}

const Jobs = ({ jobs }: JobProps) => {
  const careersRef = useRef<HTMLDivElement>(null);

  const scrollToCareers = () => {
    if (careersRef.current) {
      careersRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div data-testid="jobs" className="px-16 sm:px-28">
      <div className="mx-auto max-w-container-lg">
        <Header onButtonClick={scrollToCareers} />
        <Statistics />
        <Careers careersRef={careersRef} jobs={jobs} />
        <Timeline />
        <Testimonials className="mb-[123px]" />
        <Address />
        <div className="my-48 flex w-full items-end border-0 border-b border-solid border-grayscale-gray sm:my-80 sm:items-center"></div>
        <ContactUs />
      </div>
    </div>
  );
};

export default Jobs;
